import { RouteRecordRaw } from 'vue-router'

import QRCode from '@/popup/components/views/Home/QRCode/QRCode.vue'
import ImportProfile from '@/popup/components/views/Home/QRCode/ImportProfile.vue'
import ImportWaiting from '@/popup/components/views/Home/QRCode/ImportWaiting.vue'
import ImportScan from '@/popup/components/views/Home/QRCode/ImportScan.vue'
import ImportRequestAccess from '@/popup/components/views/Home/QRCode/ImportRequestAccess.vue'

const importRoutes: Array<RouteRecordRaw> = [
  { path: '/qrcode', name: 'qrcode', component: QRCode },
  {
    path: '/qrcode/import-profile-dapp/:id',
    name: 'import-profile-dapp',
    component: ImportProfile,
  },
  {
    path: '/qrcode/import-scan',
    name: 'import-scan',
    component: ImportScan,
  },
  {
    path: '/qrcode/import-profile/:address',
    name: 'import-profile',
    component: ImportProfile,
  },
  {
    path: '/qrcode/import-request-access',
    name: 'import-request-access',
    component: ImportRequestAccess,
  },
  {
    path: '/qrcode/import-waiting',
    name: 'import-waiting',
    component: ImportWaiting,
  },
]

export default importRoutes
